// apps/web/src/features/finance/revenue/api.ts (#602)
// Thin wrapper over `request<T>` for the admin-only revenue dashboard.
// The Zod schema is forwarded so the response is validated at the
// boundary — drift between `@magimp/shared` and the backend surface
// fails loudly here instead of corrupting React state silently.
import type { ZodType } from 'zod';
import {
  RevenueDashboardSchema,
  type RevenueDashboard,
  type RevenueMonthKey,
} from '@magimp/shared';
import { request } from '../../../api/client.js';

export function fetchRevenueDashboard(
  monthKey?: RevenueMonthKey,
  opts: { signal?: AbortSignal } = {},
): Promise<RevenueDashboard> {
  const query = monthKey ? { month: monthKey } : undefined;
  const requestOpts: { signal?: AbortSignal; query?: { month: string } } = {};
  if (opts.signal) requestOpts.signal = opts.signal;
  if (query) requestOpts.query = query;
  return request<RevenueDashboard>(
    '/finance/revenue',
    { method: 'GET' },
    requestOpts,
    RevenueDashboardSchema as unknown as ZodType<RevenueDashboard>,
  );
}
